import { AboutCareersPage } from "@nvb/ui";
import { usePageContext } from "vike-react/usePageContext";

import type { ISiteVacanciesResponse } from "@nvb/ui";

/**
 * The vacancies come from the public feed. The build-time snapshot travels in
 * `pageContext.initialData` (see `pages/+onBeforeRender.ts`) and seeds the
 * page, which still refetches the live feed on mount.
 */
export default function Page() {
	const { initialData } = usePageContext();
	const vacancies = initialData?.vacancies as ISiteVacanciesResponse | undefined;

	return <AboutCareersPage {...(vacancies ? { initialVacancies: vacancies } : {})} />;
}
